import React from 'react';
import Image from '../Components/Reusable/Image';
import { PngImages,SvgImages } from '../Utils/LocalImages';
const ShareButtons = ({ socialMediaLinks, blogDataId }) => {
  const postUrl = window.location.href; // or the specific URL of the blog post
  const postTitle = blogDataId.title;

  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`, '_blank');
  };

  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(postUrl)}`, '_blank');
  };

  const shareOnTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}`, '_blank');
  };

  // const shareOnInstagram = () => {
  //   navigator.clipboard.writeText(postUrl).then(() => {
  //     alert("URL copied to clipboard. Open Instagram and paste the URL in your bio or a post.");
  //   });
  // };
  const shareOnWhatsApp = () => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(postTitle + " " + postUrl)}`, '_blank');
  };

  return (
    <div className="d-flex flex-wrap gap-2 mt-0">
      <div className="socialMediaIconContainer cursor-pointer" onClick={shareOnFacebook}>
        <Image className="socialMediaIcon" src={SvgImages.facebook} alt="Share on Facebook" />
      </div>
      <div className="socialMediaIconContainer cursor-pointer" onClick={shareOnLinkedIn}>
        <Image className="socialMediaIcon" src={SvgImages.linkedin} alt="Share on LinkedIn" />
      </div>
      <div className="socialMediaIconContainer cursor-pointer" onClick={shareOnTwitter}>
        <Image className="socialMediaIcon" src={SvgImages.twitter} alt="Share on Twitter" />
      </div>
      {/* <div className="socialMediaIconContainer cursor-pointer" onClick={shareOnInstagram} aria-label="Share on Instagram">
        <Image className="socialMediaIcon" src={SvgImages.instagram} alt="Share on Instagram" />
      </div> */}

       {/* for whatsapp */}

      <div className="socialMediaIconContainer cursor-pointer" onClick={shareOnWhatsApp} aria-label="Share on WhatsApp">
        <Image className="socialMediaIcon" src={SvgImages.whatsapp} alt="Share on WhatsApp" />
      </div>
      
    </div>
  );

  // for Checking Links' Protypes

//   ShareButtons.PropTypes = {
//     socialMediaLinks: PropTypes.array.isRequired,
//     blogDataId: PropTypes.shape({
//       title: PropTypes.string,
//     }),
};

export default ShareButtons;
